/* eslint-disable import/no-cycle */
import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import { createUseStyles } from '@glu/theming';
import LocaleContext from '../../locale/LocaleContext';

import { maxCharactersTemplate } from '../../gluValidation/utils';
import { lt } from '../../../utils/validations/gluValidations';

import Input from './WireInput';

import { PAYMENT_TYPES } from '../../../constants';
import { specialChars } from '../utils';
import { getPaymentType } from '../../createPayment/CreatePayment.utils';

const styles = () => ({
  labelClass: {
    display: 'block'
  }
});

const useStyles = createUseStyles(styles);

const PurposeOfWireComponent = ({ data, formState, isTemplate, onChange }) => {
  const locale = useContext(LocaleContext);
  const classes = useStyles();

  const requiredOnPrefs = {
    purposeOfWireForDomestic: PAYMENT_TYPES.WIRE.DOMESTIC,
    purposeOfWireForInternational: PAYMENT_TYPES.WIRE.INTERNATIONAL
  };

  let validators = [
    lt({ maxLength: 16, msg: maxCharactersTemplate(locale, 16) }),
    specialChars({ locale, paymentType: formState.paymentTypeStr, prefs: data.wirePreferences })
  ];

  const prefs = Object.keys(requiredOnPrefs);
  const requiredAt = [].concat(
    ...prefs.map((p) => data.wirePreferences[p] && requiredOnPrefs[p]).filter(Boolean)
  );

  const paymentType = get(
    formState,
    'paymentType[0].type',
    getPaymentType(formState, data.paymentTypeOptions, { template: isTemplate })
  );
  const available = requiredAt.includes(paymentType);
  const reqValidator = { required: true, msg: locale['validation.required'] };

  if (available) {
    validators = [...validators, reqValidator];
  }

  const inputProps = {
    className: 'form-group',
    debounceInput: true,
    id: 'purpose',
    name: 'purpose',
    label: locale['create.payment.purpose'],
    labelClass: classes.labelClass,
    onChange,
    maxLength: 16,
    validators,
    optional: !available,
    defaultValue: formState.purpose
  };
  return <Input {...inputProps} />;
};

PurposeOfWireComponent.propTypes = {
  data: PropTypes.shape({}).isRequired,
  onChange: PropTypes.func.isRequired,
  formState: PropTypes.shape({}).isRequired,
  isTemplate: PropTypes.bool.isRequired
};

export default PurposeOfWireComponent;
